import React from "react";
import styled from "styled-components";
import { FaLaptop, FaUsersCog, FaCloud } from "react-icons/fa";

const editions = [
  {
    icon: <FaLaptop />,
    title: "Solo Edition",
    subtitle: "Perfect for individuals and small chamas",
    features: [
      "Offline-first, no internet required",
      "One-time purchase, lifetime access",
      "Secure local storage",
      "Affordable and simple to use"
    ],
    badge: "Best for small teams"
  },
  {
    icon: <FaUsersCog />,
    title: "Team Edition",
    subtitle: "For chamas or SACCOs with multiple admins",
    features: [
      "Role-based access control",
      "Multi-admin collaboration",
      "Sync across team devices",
      "Optional cloud backup"
    ],
    badge: "Most popular"
  },
  {
    icon: <FaCloud />,
    title: "Cloud Edition",
    subtitle: "For distributed teams and larger organizations",
    features: [
      "Access from anywhere",
      "Multiple group hosting",
      "Automated backups & updates",
      "SMS, email & API integrations"
    ],
    badge: "Advanced features"
  }
];

export default function EditionsSection() {
  return (
    <SectionWrapper id="products">
      <div className="container">
        <h2 className="font40 extraBold textCenter" style={{ color: "purple" }}>
          Choose the ChamaFlow Edition That Fits Your Group
        </h2>
        <p className="font16 textCenter" style={{ maxWidth: "700px", margin: "20px auto" }}>
          From small teams to large organizations, ChamaFlow scales to fit your savings group — offline or online.
        </p>
        <CardGrid>
          {editions.map((edition, idx) => (
            <Card key={idx}>
              <IconWrapper>{edition.icon}</IconWrapper>
              <h3 className="font20 extraBold">{edition.title}</h3>
              <p className="font14 italic" style={{ marginBottom: "10px" }}>{edition.subtitle}</p>
              <ul>
                {edition.features.map((feat, i) => (
                  <li key={i} className="font14">✅ {feat}</li>
                ))}
              </ul>
              <EditionBadge>{edition.badge}</EditionBadge>
            </Card>
          ))}
        </CardGrid>
      </div>
    </SectionWrapper>
  );
}

const SectionWrapper = styled.section`
  padding: 80px 0;
  background-color: #f9f9ff;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 30px;
  margin-top: 40px;
`;

const Card = styled.div`
  background: #fff;
  padding: 30px;
  border-radius: 18px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.05);
  transition: 0.3s ease;
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.08);
  }
`;

const IconWrapper = styled.div`
  font-size: 40px;
  color: purple;
  margin-bottom: 15px;
`;

const EditionBadge = styled.div`
  margin-top: 15px;
  display: inline-block;
  background: #ffd700;
  color: #000;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: bold;
`;

